export default [
    { value: true, text: "Sim", variante: "success" },
    { value: false, text: "Não", variante: "warning" },
]